import { Check, X } from 'lucide-react';
import { useFormContext } from 'react-hook-form';

import { Button } from '@/_components';
import { booleanFormToUpdateConverter } from '@/_schemas/generic/boolean-enum';
import type { OnPartialUpdate } from '@/_schemas/types';

import type { AgreementUpdateSchema } from '../../schemas';

export function SubsidiesStatusButtonInput({
  isPending,
  onPartialUpdate,
}: {
  isPending: boolean;
  onPartialUpdate: OnPartialUpdate<AgreementUpdateSchema>;
}) {
  const form = useFormContext();
  const [status] = form.watch(['activate_subsidy_billing']);

  const handleStatusCtrl = () => {
    const newOption = !status;
    form.setValue('activate_subsidy_billing', newOption);
    onPartialUpdate(
      { activate_subsidy_billing: booleanFormToUpdateConverter(newOption) },
      'Subsidies billing status updated',
      false
    );
  };

  return (
    <Button
      as="link"
      className="justify-start"
      disabled={isPending}
      size="xs"
      onClick={handleStatusCtrl}
      icon={status ? Check : X}
      iconClassName={status ? 'text-success' : 'text-error'}
      aria-label="Toggle Status"
    >
      {status ? 'Subsidies Billing Active' : 'Subsidies Billing Inactive'}
    </Button>
  );
}
